import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 6 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"1.125\" cy=\"7.875\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle><circle cx=\"4.5\" cy=\"7.875\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle><circle cx=\"1.125\" cy=\"4.5\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle><circle cx=\"4.5\" cy=\"4.5\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle><circle cx=\"1.125\" cy=\"1.125\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle><circle cx=\"4.5\" cy=\"1.125\" r=\"1.125\" fill=\"#fff\" fill-opacity=\".66\"></circle>", 6)
  ]))]))
}
export default { render: render }